<template>
  <div class="app-change-auto-top-up-wrapper">
    <slot name="txtBeforeChangeAutoTopUp"></slot>
    <activate-auto-top-up-wrapper
      v-if="canActivate"
      :monthly-value="monthlyValue"
      :auto-top-up="autoTopUp"
      @refresh="refreshQuery()"
    >
      <template #txtBeforeActivateAutoTopUp><slot name="txtChangeAutoTopBeforeAutoTopUp"></slot></template>
      <template #btnActivateNext><slot name="btnActivateNext"></slot></template>
      <template #txtActivateHeaderMonthlyAutoTopUp><slot name="txtChangeActivateHeaderMonthlyAutoTopUp"></slot></template>
      <template #lblActivateMonthlyAutoTopUp><slot name="lblChangeActivateMonthlyAutoTopUp"></slot></template>
      <template #lblActivateMonthlyAmountAutoTopUp><slot name="lblChangeActivateMonthlyAmountAutoTopUp"></slot></template>
      <template #txtActivateHeaderByLimitAutoTopUp><slot name="txtChangeActivateHeaderByLimitAutoTopUp"></slot></template>
      <template #lblActivateByLimitAutoTopUpFirst><slot name="lblChangeActivateByLimitAutoTopUpFirst"></slot></template>
      <template #lblActivateByLimitAutoTopUpSecond><slot name="lblChangeActivateByLimitAutoTopUpSecond"></slot></template>
      <template #txtAutoTopUpSuccessActivated><slot name="txtChangeAutoTopUpSuccessActivated"></slot></template>
      <template #btnAutoTopUpActivatedSuccessBack><slot name="btnChangeAutoTopUpDActivatedSuccessBack"></slot></template>
      <template #txtAutoTopUpSuccessActivatedAfter><slot name="txtChangeAutoTopUpSuccessActivatedAfter"></slot></template>
    </activate-auto-top-up-wrapper>
    <deactivate-auto-top-up-wrapper
      v-if="canDeactivate"
      :auto-top-up="autoTopUp"
      @refresh="refreshQuery()"
    >
      <template #txtDeactivateBeforeAutoTopup><slot name="txtChangeAutoTopBeforeAutoTopUp"></slot></template>
      <template #txtDeactivateBeforeActiveAutoTopup><slot name="txtChangeDeactivateBeforeActiveAutoTopup"></slot></template>
      <template #txtDeactivateActiveAutoTopUpDayOfMonth><slot name="txtChangeDeactivateActiveAutoTopUpDayOfMonth"></slot></template>
      <template #txtDeactivateActiveAutoTopUpAccountBalance><slot name="txtChangeDeactivateActiveAutoTopUpAccountBalance"></slot></template>
      <template #lblDeaktivateAutoTopUp><slot name="lblChangeDeaktivateAutoTopUp"></slot></template>
      <template #btnDeactivateNext><slot name="btnChangeDeactivateNext"></slot></template>
      <template #txtAutoTopUpSuccessDeactivated><slot name="txtChangeAutoTopUpSuccessDeactivated"></slot></template>
      <template #btnAutoTopUpDeactivatedSuccessBack><slot name="btnChangeAutoTopUpDeactivatedSuccessBack"></slot></template>
      <template #txtAutoTopUpSuccessDeactivatedAfter><slot name="txtChangeAutoTopUpSuccessDeactivatedAfter"></slot></template>
    </deactivate-auto-top-up-wrapper>
    <div class="noSavedPayment" v-if="noPayment">
      <div class="text"><slot name="txtChangeAutoTopBeforeAutoTopUp"></slot></div>
      <div class="noPayment"><slot name="txtChangeAutoTopNoSavedPayment"></slot></div>
    </div>
  </div>
</template>
<script>
import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import gql from 'graphql-tag'
import ActivateAutoTopUpWrapper from './ActivateAutoTopUpWrapper.vue'
import DeactivateAutoTopUpWrapper from './DeactivateAutoTopUpWrapper.vue'
import transaction from '@/mixins/transaction'

export default {
  name: 'ChangeAutoTopUpWrapper',
  data () {
    return {
      monthlyValue: [2, 19],
      autoTopUp: {
        activationPossible: false,
        active: false,
        topUp: {
          amount: 0,
          trigger: 0,
          type: null
        }
      }
    }
  },
  methods: {
    refreshQuery () {
      this.$apollo.queries.autoTopUp.refresh()
    }
  },
  components: { DeactivateAutoTopUpWrapper, ActivateAutoTopUpWrapper },
  computed: {
    canDeactivate () {
      return this.autoTopUp.active
    },
    noPayment () {
      return this.autoTopUp.activationPossible === false
    },
    canActivate () {
      return this.canDeactivate === false && this.autoTopUp.activationPossible
    }
  },
  mixins: [
    transaction('changeAutoTopUp')
  ],
  apollo: {
    autoTopUp: function () {
      return wrapQuery(gql`query changeAutoTopUp {
        autoTopUp{
          activationPossible,
          active,
           topUp {
             amount,
             trigger,
             type
            }
        }
      }`, this, 'autoTopUp')
    }
  }
}
</script>
